// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__uyxL4","header":"ReportDetails_header__3rQV9","title":"ReportDetails_title__2VzMr","left":"ReportDetails_left__1erP1"};